import React, { useEffect, createElement } from 'react';
export const META_PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Mounts the Meta (Facebook) Pixel base code and fires a PageView event.
 * Wrapped in try/catch so a failed third-party script load never breaks the page
 * (preview iframes, ad-blockers, network errors, etc.).
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (window.fbq) {
        try {
          window.fbq('track', 'PageView');
        } catch {}
        return;
      }
      // Standard Meta Pixel base code — adapted with safety guards
      ;
      (function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return;
        const n: any = function () {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        f.fbq = n;
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        // Silently swallow load failures (e.g. ad-blockers, sandboxed iframes)
        t.onerror = () => {};
        const head = b.getElementsByTagName(e)[0];
        if (head && head.parentNode) {
          head.parentNode.insertBefore(t, head);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (err) {
      // Never let pixel issues break the page
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[MetaPixel] init skipped:', err);
      }
    }
  }, []);
  return <noscript data-id="element-103">
      <img height={1} width={1} style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-104" />
    </noscript>;
}
/**
 * Fire a Meta Pixel standard or custom event.
 * Safe no-op if the pixel hasn't loaded yet or the call throws.
 */
export function trackPixelEvent(event: string, data?: Record<string, unknown>, type: 'track' | 'trackCustom' = 'track') {
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    if (data) {
      window.fbq(type, event, data);
    } else {
      window.fbq(type, event);
    }
  } catch (err) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[MetaPixel] event failed:', event, err);
    }
  }
}